module.exports = __webpack_public_path__ + "static/media/tech-assurance.f0adbc7d.webp";